import React from "react";
import { Steps } from "intro.js-react";
import introData from "../../data/intro.json";

const steps = introData[0].pasos;
const introOptions = {
  nextLabel: ">",
  prevLabel: "<",
  skipLabel: "Saltar",
  doneLabel: "Finalizar"
};

/**
 * Se encarga de construir un modal dialog que permite desplegar
 * mensajes.
 */
class IntroJS extends React.Component {
  /**
   * @field
   */
  state = {
    stepsEnabled: false,
    initialStep: 0
  };

  /**
   * Se setea la refencia a la instancia del componente.
   */
  componentDidMount() {
    this.props.onRef(this);
  }

  /**
   * se encarga de recuperar la lista de pasos.
   */
  getSteps() {}

  /**
   * Se encarga de manejar el exit de introjs.
   */
  hide = () => {
    this.setState(() => ({ stepsEnabled: false }));
    if (this.props.onHide) {
      this.props.onHide();
    }
  };

  /**
   * Se encarga de manejar el exit de introjs.
   */
  show = () => {
    this.setState({ stepsEnabled: true });
    if (this.props.onShow) {
      this.props.onShow();
    }
  };
  /**
   * Se dispara cuando cambia la opción.
   * @param {*} args
   */
  onChange(idx) {
    if (this.props.onChange) {
      this.props.onChange(idx, steps[idx]);
    }
  }
  
  /**
   * Renderiza el componente
   */
  render() {
    const { stepsEnabled, initialStep } = this.state;
    return (
      <React.Fragment>
        <Steps
          enabled={stepsEnabled}
          onChange={idx => this.onChange(idx)}
          steps={steps}
          initialStep={initialStep}
          options={introOptions}
          onExit={this.hide}
        />
      </React.Fragment>
    );
  }
}
export default IntroJS;
